"use client";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Hero from "./Hero";
import AboutIntro from "./AboutIntro";
import AnnouncementBar from "./AnnouncementBar";
import WhyChooseUs from "./WhyChooseUs";
import PricingRates from "./PricingRates";
import StepsSection from "./StepsSection";
import WhyConsolidate from "./WhyConsolidate";
import SmartMoneyInsights from "./SmartMoneyInsights";
import EligibilityCriteria from "./EligibilityCriteria";
import FeesCharges from "./FeesCharges";
import Testimonials from "./Testimonials";
import ReadyCta from "./ReadyCta";
import FaqSection from "./FaqSection";

function PaisaPopLanding() {
  return (
    <div className="min-w-screen bg-white">
      <Navbar />
      <Hero />
      <AboutIntro />
      <AnnouncementBar />
      <WhyChooseUs />
      <PricingRates />
      <StepsSection />
      <WhyConsolidate />
      <SmartMoneyInsights />
      <EligibilityCriteria />
      <FeesCharges />
      <Testimonials />
      <ReadyCta />
      <FaqSection />
      <Footer />
    </div>
  );
}

export default PaisaPopLanding;
